// extracted by mini-css-extract-plugin
export default {"wrapper":"KoDZ1Q5","pretargetingBudget":"BghF0RJ"};